

import { createSlice } from '@reduxjs/toolkit';


const initialState = {
    list: [],
    savedList: [],
    tempStatus: 'saved'
}

const listsMatch = (a, b) => JSON.stringify(a) === JSON.stringify(b);


let defaultControl = {
    id: null,
    name: "",
    control_group_id: null,
    sort_order: null,
    control_type: "",
    target: "",
    command: "",
    topic: "",
    payload: "",
    url: "",
    value: "",
    require_feedback: false,
    expected_replies: 1,    // Command + confirm delivery: distinct devices that must reply
    hidden: false
}

// Pre-split codebase saved control_type as 'mqtt' | 'http'. Both of those
// were always freeform (raw topic / raw url) — 'structured_mqtt' is new,
// so there's nothing old to map onto it. Runs once per incoming control;
// a no-op for anything already using the new values.
const migrateControlType = (control) => {
    if (control.control_type === 'mqtt') return { ...control, control_type: 'freeform_mqtt' };
    if (control.control_type === 'http') return { ...control, control_type: 'freeform_http' };
    // Confirmation is Command-only now. Controls saved while freeform MQTT
    // still offered the checkbox may carry require_feedback: true; scrub it
    // so a hidden flag can't silently drive send behavior.
    if (control.control_type === 'freeform_mqtt' && control.require_feedback) {
        return { ...control, require_feedback: false };
    }
    return control;
}


const controlsTempSlice = createSlice({
    name: 'tempControls',
    initialState,
    reducers: {

        setTempControls: (state, action) => {
            let needsSave = false;
            state.list = action.payload.map(control => {
                const migrated = migrateControlType(control);
                if (migrated.control_type !== control.control_type) needsSave = true;
                if (!migrated.id) {
                    needsSave = true;
                    return { ...migrated, id: crypto.randomUUID() };
                }
                return migrated;
            });
            state.savedList = JSON.parse(JSON.stringify(state.list));
            state.tempStatus = needsSave ? 'unsaved' : 'saved';
        },

        setSaved: (state) => { 
            console.log("setting tempStatus to saved");
            state.savedList = JSON.parse(JSON.stringify(state.list));
            state.tempStatus = 'saved'; 
        },
    
        addTempControl: (state) => {
            let modifiedDefaultControl = { ...defaultControl }; 
            modifiedDefaultControl.sort_order = state.list.length + 1;
            modifiedDefaultControl.id = crypto.randomUUID();
            state.list.push(modifiedDefaultControl);
            state.tempStatus = listsMatch(state.list, state.savedList) ? 'saved' : 'unsaved';
        },

        editTempControls: (state, action) => {
            const { index, controlKey, value } = action.payload;
            state.list[index][controlKey] = value;
            state.tempStatus = listsMatch(state.list, state.savedList) ? 'saved' : 'unsaved';
        },
          
        moveTempControlUp: (state, action) => {
            const index = action.payload;
            if (index === 0) return;
            [state.list[index - 1], state.list[index]] = [state.list[index], state.list[index - 1]];
            state.list.forEach((item, i) => { item.sort_order = i + 1; });
            state.tempStatus = listsMatch(state.list, state.savedList) ? 'saved' : 'unsaved';
        },

        moveTempControlDown: (state, action) => {
            const index = action.payload;
            if (index === state.list.length - 1) return;
            [state.list[index], state.list[index + 1]] = [state.list[index + 1], state.list[index]];
            state.list.forEach((item, i) => { item.sort_order = i + 1; });
            state.tempStatus = listsMatch(state.list, state.savedList) ? 'saved' : 'unsaved';
        },

        deleteTempControl: (state, action) => {
            let index = action.payload;
            state.list.splice(index, 1);
            state.tempStatus = listsMatch(state.list, state.savedList) ? 'saved' : 'unsaved';
        }

    }
});

export const { setTempControls, setSaved, addTempControl, editTempControls, deleteTempControl, moveTempControlUp, moveTempControlDown } = controlsTempSlice.actions;
export default controlsTempSlice.reducer;